import React from 'react';
import { Step } from '../types';

interface StepWizardProps {
  currentStep: Step;
}

export const StepWizard: React.FC<StepWizardProps> = ({ currentStep }) => {
  const steps = [
    { id: 'selection', label: '1. Configuración', description: 'Ruta y Fecha' },
    { id: 'planning', label: '2. Planificación', description: 'Horario y Tráfico' },
    { id: 'confirmation', label: '3. Confirmación', description: 'Resumen' },
  ];

  const getStepIndex = (s: Step) => steps.findIndex(step => step.id === s);
  const currentIndex = getStepIndex(currentStep);

  return (
    <div className="w-full bg-white border-b border-gray-100 py-3 mb-4">
      <div className="max-w-5xl mx-auto px-6">
        <div className="flex items-center justify-center gap-4 md:gap-8">
            {steps.map((step, index) => {
                const isActive = index === currentIndex;
                const isCompleted = index < currentIndex;
                const isLast = index === steps.length - 1;

                return (
                    <React.Fragment key={step.id}>
                        <div className="flex flex-col items-center bg-white relative z-10">
                            <div 
                                className={`w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center font-bold text-xs md:text-sm border-2 transition-colors duration-300 ${
                                    isActive || isCompleted 
                                        ? 'bg-blue-600 border-blue-600 text-white' 
                                        : 'bg-white border-gray-300 text-gray-400'
                                }`}
                            >
                                {isCompleted ? '✓' : index + 1}
                            </div>
                            <div className="mt-1.5 text-center">
                                <span className={`block text-[10px] md:text-xs font-semibold ${isActive ? 'text-gray-900' : 'text-gray-500'}`}>
                                    {step.label.split('. ')[1] || step.label}
                                </span>
                                <span className="hidden md:block text-[9px] text-gray-400 mt-0.5">
                                    {step.description}
                                </span>
                            </div>
                        </div>
                        {/* Línea punteada entre etapas */}
                        {!isLast && (
                            <div className="flex-1 max-w-24 md:max-w-32 border-t-2 border-dashed border-gray-200 -mt-4"></div>
                        )}
                    </React.Fragment>
                );
            })}
        </div>
      </div>
    </div>
  );
};